import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

export const toolbarStyles = {
  backgroundColor: 'white',
  borderRadius: '5px',
  boxShadow: 3,
  width: 'fit-content',
} satisfies SxProps<Theme>;

export const iconStyles = {
  p: 1,
  textAlign: 'center',
  '&:hover': {
    backgroundColor: 'grey.400',
  },
  fontSize: '2.75rem',
} satisfies SxProps<Theme>;

export const zIndexValues = { popovers: 15, toolbars: 10, handles: 5 } as const;

export const colorLightenFactor = 0.6;
